import axios from "./HttpRequestBlog";

  function  getListBlog(){
        // return axios.get('/RestApi_post.php?per_page=1');
        return axios.get('/wp-json/wp/v2/posts/?filter[category_name]=country&filter[posts_per_page]=1');
}
export {getListBlog}